import 'inputmask/dist/jquery.inputmask.min'
import { ERROR_CLASS } from '../lib/constants'

const subscribeForm = () => {
  const $FORM_SUBSCRIBE = $('.js-subscribe-block:first')

  if ($FORM_SUBSCRIBE) {
    const $INPUTS_REQUIRED = $FORM_SUBSCRIBE.find('.input[required]')
    const $SUBMIT_SUBSCRIBE = $FORM_SUBSCRIBE.find('form')

    const regExpEmail = /^[A-Z0-9._%+-]+@[A-Z0-9-]+.+\.[A-Z]{2,4}$/i

    let regExpEmailTrue = false

    const contactFormSubscribe = () => {
      const form = document.querySelector('.js-subscribe-block form')
      const data = new FormData(form)

      $.ajax({
        url: '/bitrix/services/main/ajax.php?mode=ajax&c=zug:feedback&action=subscribe&',
        processData: false,
        contentType: false,
        dataTypes: 'json',
        method: 'post',
        cache: false,
        async: false,
        data: data,
        success: function (data) {
          if (data.status === 'success') {
            $FORM_SUBSCRIBE.find('.js-subscribe-success').trigger('click')
          }

          if (data.status === 'error') {
            $FORM_SUBSCRIBE.find('.js-subscribe-error').trigger('click')
          }
        },
      })
    }

    const email = $('[data-name="email"]')

    const isPlaceholderVisible = () => {
      $INPUTS_REQUIRED.on('input', function () {
        const $t = $(this)

        const $tPlaceholder = $t.parent().find('.js-contact-form-input-placeholder')

        if ($t.val().trim() === '') {
          phoneMask()
          $tPlaceholder.show()
        } else {
          $tPlaceholder.hide().removeClass(ERROR_CLASS)
        }
      })
    }

    const checkInputValue = function (value, regexp) {
      if (regexp.test(value)) return true
    }

    const checkEmailValue = () => {
      const checkEmail = checkInputValue(email.val(), regExpEmail)

      if (!checkEmail) {
        email.parent().addClass('error-mail')
        regExpEmailTrue = false
      } else {
        email.parent().removeClass('error-mail')
        regExpEmailTrue = true
      }
    }

    const checkInputValByFocusout = () => {
      $.each($INPUTS_REQUIRED, function (_, el) {
        const $el = $(el)

        $el.on('focusout', function () {
          if ($el.val().trim() === '') {
            $el.parent().find('.js-contact-form-input-placeholder').addClass(ERROR_CLASS)

            if ($el[0].name === 'email') {
              email.parent().removeClass('error-mail')
            }
          }
        })
      })
    }

    $INPUTS_REQUIRED.val('')

    email.on('input', () => {
      checkEmailValue()
    })

    isPlaceholderVisible()
    checkInputValByFocusout()

    $SUBMIT_SUBSCRIBE.on('submit', function (event) {
      event.preventDefault()
      contactFormSubscribe()
    })
  }
}

export const subscribeFunctions = () => {
  subscribeForm()
}
